import React from 'react';
import AuthCard from '../../components/AuthCard';
import '../Auth/Auth.css';

const Signup = () => {
  return (
    <div className="app auth-app">
      <AuthCard type="signup" />
    </div>
  );
};

export default Signup;
